import { jsx as _jsx } from "react/jsx-runtime";
/**
 * The scene files on the way down to the node being rendered: the edited root, then each instance
 * whose sub-scene authored nodes below it. `useIsInstantiated` reads it to give a gizmo the look
 * Godot gives a node the edited root does not own (`instanceOwners.ts`).
 */
import { createContext, useContext, useMemo } from 'react';
import { ROOT_OWNER, instanceOwner } from '../instanceOwners';
import { useInstancedScenePaths } from './InstancedScenePathsContext';
const NO_PATHS = [];
const InstanceOwnersContext = createContext([ROOT_OWNER]);
InstanceOwnersContext.displayName = 'InstanceOwnersContext';
/** Starts the list with the edited root, which lists `editableInstances`. */
export function EditedRootProvider({ editableInstances = NO_PATHS, children }) {
    const owners = useMemo(() => [{ ...ROOT_OWNER, editablePaths: editableInstances }], [editableInstances]);
    return _jsx(InstanceOwnersContext.Provider, { value: owners, children: children });
}
/**
 * Adds the instance at `path` to the list. Mounted where the dispatcher renders an instance, so the
 * scenes that enclose it are the ones the ambient chain holds.
 */
export function InstanceOwnerProvider({ path, editablePaths = NO_PATHS, children, }) {
    const enclosing = useContext(InstanceOwnersContext);
    const level = useInstancedScenePaths().length + 1;
    const owners = useMemo(() => [...enclosing, instanceOwner(enclosing, level, path, editablePaths)], [enclosing, level, path, editablePaths]);
    return _jsx(InstanceOwnersContext.Provider, { value: owners, children: children });
}
/** The edited root and each instance above the node, outermost first. */
export function useInstanceOwners() {
    return useContext(InstanceOwnersContext);
}
//# sourceMappingURL=InstanceOwnersContext.js.map